// Texts for the world 'dishes': the name on the map, the level titles and the comic words in the scene (scene.ts), per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Opvasken',
    levels: {
      'first-roll': { title: 'Første rul' },
      'drip': { title: 'Dryppet' },
      'other-way': { title: 'Den anden vej' },
      'pour-more': { title: 'Hæld mere' },
      'tea-towel': { title: 'Viskestykket' },
      'sponge': { title: 'Svampen' },
      'mirror-tray': { title: 'Spejlbakken' },
      'zigzag': { title: 'Zigzag' },
      'speed-up': { title: 'Fart på' },
      'ladle-hop': { title: 'Slevens hop' },
      'speed-to-hop': { title: 'Fart til hop' },
      'over-the-sink': { title: 'Over vasken' },
      'long-way': { title: 'Den lange vej' },
      'glove': { title: 'Handsken' },
      'masterpiece': { title: 'Mesterværket' },
    },
    scene: {
      'splash': 'PLASK!',
      'splosh': 'SKVULP!',
    },
  },
  en: {
    name: 'The washing-up',
    levels: {
      'first-roll': { title: 'First roll' },
      'drip': { title: 'The drip' },
      'other-way': { title: 'The other way' },
      'pour-more': { title: 'Pour some more' },
      'tea-towel': { title: 'The tea towel' },
      'sponge': { title: 'The sponge' },
      'mirror-tray': { title: 'The mirror tray' },
      'zigzag': { title: 'Zigzag' },
      'speed-up': { title: 'Speed up' },
      'ladle-hop': { title: 'The ladle hop' },
      'speed-to-hop': { title: 'Speed for a hop' },
      'over-the-sink': { title: 'Over the sink' },
      'long-way': { title: 'The long way round' },
      'glove': { title: 'The glove' },
      'masterpiece': { title: 'The masterpiece' },
    },
    scene: {
      'splash': 'SPLASH!',
      'splosh': 'SPLOSH!',
    },
  },
});
